/**
 * Only put public interfaces in here
 */
export var BuildabilityStatusV2;
(function (BuildabilityStatusV2) {
    BuildabilityStatusV2["UNKNOWN"] = "unknown";
    BuildabilityStatusV2["INCOMPLETE"] = "incomplete";
    BuildabilityStatusV2["NOT_BUILDABLE"] = "not buildable";
    BuildabilityStatusV2["BUILDABLE"] = "buildable";
})(BuildabilityStatusV2 || (BuildabilityStatusV2 = {}));
